import {
  StoreInfo,
  storeInformationQueries,
} from "$/hooks/use-store-information"
import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

type StoreModuleFlag =
  | "whiteLabelBookingEnabled"
  | "companiesEnabled"
  | "customerClubEnabled"

// Redirects home when a Julo admin has turned the module off for the store
export const requireStoreModule = async (
  queryClient: QueryClient,
  flag: StoreModuleFlag,
) => {
  const storeInfo = await queryClient.ensureQueryData(
    storeInformationQueries.detail(queryClient),
  )
  const currentStore: StoreInfo | undefined = storeInfo.stores.find(
    (store) => store.id === storeInfo.storeId,
  )
  if (!currentStore?.[flag]) {
    throw redirect({ to: "/", replace: true })
  }
}
